import { styles as componentStyles } from './view.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { unsafeCSS } from 'lit-element';
import { styles as helperStyles } from '../../../../assets/style-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';

export const styles = [
  unsafeCSS(`${componentStyles}`),
  unsafeCSS(`${commonStyles}`),
  unsafeCSS(`${helperStyles}`),
  unsafeCSS(`${flexboxHelpersStyles}`),
];
